import isPredeliveryAndTotalPaymentDueZero from "../../../helpers/isPredeliveryAndTotalPaymentDueZero";
import isLoanClosed from "../../../helpers/isLoanClosed";
var getPayLaterPN4DataSections = function (accountSummaryData, autopayStatusData, t) {
    var installment = accountSummaryData.installment, credit = accountSummaryData.credit, billing = accountSummaryData.billing, conditions = accountSummaryData.conditions;
    var totalMinimumPaymentDue = billing === null || billing === void 0 ? void 0 : billing.totalMinimumPaymentDue;
    var isClosed = isLoanClosed(conditions);
    var isPreDelivery = isPredeliveryAndTotalPaymentDueZero(conditions, totalMinimumPaymentDue);
    var shouldShowUnavailableText = isClosed || isPreDelivery;
    var unavailableText = t("error.uiComponent");
    return {
        dataSections: [
            {
                heading: t("grid.titles.loanSummary"),
                sectionName: "loan-summary",
                dataElements: [
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.principalAmount,
                        label: t("grid.amountFinanced"),
                        type: "amount",
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.startDate,
                        label: t("grid.labels.loanStartDate"),
                        type: "date",
                    },
                ],
            },
            {
                heading: t("grid.titles.payments"),
                sectionName: "payments",
                dataElements: [
                    {
                        value: shouldShowUnavailableText
                            ? unavailableText
                            : billing === null || billing === void 0 ? void 0 : billing.nextPaymentDate,
                        label: t("grid.labels.nextPaymentDate"),
                        type: shouldShowUnavailableText ? "text" : "date",
                    },
                    {
                        value: shouldShowUnavailableText
                            ? unavailableText
                            : billing === null || billing === void 0 ? void 0 : billing.totalMinimumPaymentDue,
                        label: t("grid.labels.nextAmountDue"),
                        type: shouldShowUnavailableText ? "text" : "amount",
                        toolTipText: t("grid.labels.nextAmountPN4Tooltip"),
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.lastPaymentDate,
                        label: t("grid.labels.lastPaymentDate"),
                        type: "date",
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.lastPaymentAmount,
                        label: t("grid.labels.lastPaymentAmount"),
                        type: "amount",
                    },
                    {
                        value: (autopayStatusData === null || autopayStatusData === void 0 ? void 0 : autopayStatusData.enrollment)
                            ? t("grid.labels.autoPayStatus.on")
                            : t("grid.labels.autoPayStatus.off"),
                        label: t("grid.labels.autoPayStatus.text"),
                        type: "text",
                    },
                ],
            },
            {
                heading: t("grid.titles.loanInformation"),
                sectionName: "loan-information",
                dataElements: [
                    {
                        value: credit === null || credit === void 0 ? void 0 : credit.currentBalance,
                        label: t("grid.labels.estimatedPayoffAmount"),
                        type: "amount",
                        toolTipText: t("grid.labels.estimatedPayoffAmountTooltip"),
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.fixedPaymentAmount,
                        label: t("grid.labels.scheduledLoanPayment"),
                        type: "amount",
                    },
                ],
            },
        ],
    };
};
export default getPayLaterPN4DataSections;
//# sourceMappingURL=getPayLaterPN4DataSections.js.map